import {useEffect, useState} from 'react';
import type {ProductCatalogItem, StockMatrix} from '@ozon-ai/ozon/contracts';
import {api} from '../../../api/client';
import {addCalendarDays, businessToday} from '@ozon-ai/periods';

export function useProductCatalogWithStocks() {
	const [catalog, setCatalog] = useState<ProductCatalogItem[] | null>(null);
	const [stockByOfferId, setStockByOfferId] = useState<Map<string, number>>(new Map());
	const [stockDay, setStockDay] = useState<string | null>(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		let cancelled = false;
		setLoading(true);
		setError(null);

		const to = businessToday();
		const from = addCalendarDays(to, -14);

		void Promise.all([
			api.get<ProductCatalogItem[]>('/products/catalog'),
			api.post<StockMatrix>('/stocks/matrix', {from, to}),
		])
			.then(([items, matrix]) => {
				if (cancelled) return;
				setCatalog(items);
				const latestDay = matrix.days[0] ?? null;
				setStockDay(latestDay);
				const map = new Map<string, number>();
				if (latestDay) {
					for (const row of matrix.rows) {
						if (Object.prototype.hasOwnProperty.call(row.quantities, latestDay)) {
							map.set(row.offerId, row.quantities[latestDay]);
						}
					}
				}
				setStockByOfferId(map);
			})
			.catch((err: unknown) => {
				if (!cancelled) {
					setCatalog(null);
					setError(err instanceof Error ? err.message : 'Не удалось загрузить товары');
				}
			})
			.finally(() => {
				if (!cancelled) setLoading(false);
			});

		return () => {
			cancelled = true;
		};
	}, []);

	return {
		catalog,
		stockByOfferId,
		stockDay,
		loading,
		error,
	};
}
